export default __webpack_public_path__ + "static/media/dive_deeper2.c3414fed.svg";